import React, { Component } from 'react';
import s from './Appeal.css';

export default class Appeal extends Component {
  render(){
    return pug`
      div(className=s.appeal)
        p 新しくて面白いものを作るのが大好きです。 
          |中学時代からHTML/CSSの勉強をはじめ、情報系の大学に入学し、次席の成績で学部を卒業しました。
          |クリエイティブな仕事をするためには企画・デザインから実装まで
          strong 横断的に
          | 知っていることが重要と考えてるため、フリーランスの道を選び、
          strong 忍者プログラマー
          |として活動してきました。 
          strong
            a(href="https://japana.me") Japaname
          |や 
          strong
            a(href="http://kotodama.fumicode.com") Kotodama 
          | などひとが思いつきそうにないような
          strong 新しいユーザー体験
          | を作りユーザーを驚かせたいです。 そのため、最も得意とするフロントエンドプログラミングなどを中心として、デザインのセンスをより磨きたいし、何よりビジネスというものを一から学ばせていただきたいと思っています。 
    `;
  }
}



// WEBPACK FOOTER //
// ./src/Appeal.js